import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

const SubmissionConfirmationPage = () => {
    const { t } = useTranslation(); 
    return (
        <div className='pt-2 pb-3'>
            <p>
                {t("general.tq")}
                <span style={{ "color": "#ff0000" }}><strong>{t("general.submit")}</strong></span>
            </p>
            <Trans html="br:<br/>">
                {t("general.Declaration1")}
            </Trans>
            <p>
                <strong>{t("general.contact_Info")}</strong>
                <Trans html="br:<br/>">
                    {t("general.infoContent")}
                    <a href="mailto:retreat@shineling.org">{t("general.retreatEmail")}</a>
                </Trans>
                <br />
                <Link to={`${process.env.REACT_APP_CUSTOMER_SERVICE_LINK}${JSON.parse(localStorage.getItem("token"))}`} target="_blank" rel="noopener noreferrer">
                    {t("general.retreatChatbot")}
                </Link>
            </p>
            <p>
                -----------------------------
                <Trans html="br/:<br />">
                    <br />{t("general.snl")}
                </Trans>
            </p>
        </div>
    )
}

export default SubmissionConfirmationPage